import { Box, Skeleton } from '@mui/material';
import { FlexColumnContainer } from 'src/components/styles';

type ListSkeletonProps = {
  rows?: number;
  itemHeight?: number;
  disableTitle?: boolean;
  rowGap?: number;
  itemTitleGap?: number;
};

export default function ListSkeleton({
  rows = 5,
  itemHeight,
  disableTitle,
  rowGap = 2,
  itemTitleGap = 0.5,
}: ListSkeletonProps) {
  return (
    <Box display="flex" flexDirection="column" rowGap={rowGap}>
      {Array.from({ length: rows }).map((_, i) => {
        return (
          <FlexColumnContainer
            key={`list-skeleton-${i}`}
            gap={itemTitleGap}
            width="100%"
          >
            {!disableTitle && <Skeleton width="40%" animation="wave" />}
            <Skeleton
              variant="rounded"
              animation="wave"
              width="100%"
              height={itemHeight ?? '60px'}
            />
          </FlexColumnContainer>
        );
      })}
    </Box>
  );
}
